import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-way-movement',
  templateUrl: './way-movement.component.html',
  styleUrls: ['./way-movement.component.scss'],
  standalone: false,
})
export class WayMovementComponent implements OnInit {
  @Input() status;

  constructor() {}

  ngOnInit() {}
}
